import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Select, Spin, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';

import ErrorHandler from '../../utils/ErrorHandler';
import Notification from '../../components/controls/Notification';
import { CaseStudyAPI } from '../../utils/Api';
import { modalityList } from '../../utils/Constants';

const { Title } = Typography;
const { Option } = Select;

const ViewCaseStudy = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [dicomCollections, setDicomCollections] = useState('');

  useEffect(() => {
    CaseStudyAPI.get(`question/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('at')}` } })
      .then((res) => {
        console.log(res.data.data);
        form.setFieldsValue({ hpi: res.data.data.hpi, vital: res.data.data.vitals, labs: res.data.data.labs, modality: res.data.data.modality });
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, history);
        } else {
          Notification('Something went wrong! Please try again later', 'error');
        }
      });
  }, []);

  const handleDicomUpload = () => {
    let formData = new FormData();

    for (const key of Object.keys(dicomCollections)) {
      formData.append('dicom', dicomCollections[key]);
    }

    setLoading(true);
    CaseStudyAPI.post(`/question/dicom/${sessionStorage.getItem('qi')}`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('at')}`,
      },
    })
      .then(() => {
        Notification('Series uploaded successfully!', 'success');
      })
      .catch((err) => {
        Notification('Error', err, 'error');
      })
      .finally(() => setLoading(false));
  };

  return (
    <Spin spinning={loading}>
      <div className='center'>
        <Title level={3}>Create Case Study</Title>
      </div>
      <Card className='mb-1'>
        <Form form={form} layout='vertical'>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='hpi' label='History of Present Illness' rules={[{ required: true, message: 'Please select HPI' }]}>
                <Input placeholder='10 year old boy with testicular pain' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='vital' label='Vital' rules={[{ required: true, message: 'Please select vital' }]}>
                <Input placeholder='Tachycardia to 120' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='labs' label='Labs' rules={[{ required: true, message: 'Please select labs' }]}>
                <Input placeholder='UA with 5 WBCs/HPF' />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <Form.Item name='modality' label='Modality' rules={[{ required: true, message: 'Please select modality' }]}>
                <Select>
                  {modalityList.map((el) => (
                    <Option key={el} value={el}>
                      {el}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <input type='file' name='imgCollection' onChange={(e) => setDicomCollections(e.target.files)} multiple />
          </Col>
          {dicomCollections !== '' && (
            <Col xs={24}>
              <Button onClick={handleDicomUpload} icon={<UploadOutlined />}>
                Upload Series
              </Button>
            </Col>
          )}
        </Row>
      </Card>
    </Spin>
  );
};

export default ViewCaseStudy;
